import React from "react";
import styles from "./RewardProduct.module.css";

function RewardProduct({
  tier,
  className = "",
  compact = false,
  showPolicyRange = false,
}) {
  if (!tier) return null;

  const imageSrc = tier.image;
  const policyRange = `${tier.minimumPolicies.toLocaleString()}–${tier.maximumPolicies.toLocaleString()}`;

  return (
    <div
      className={`${styles.productVisual} ${
        compact ? styles.compact : ""
      } ${className}`}
    >
      {showPolicyRange && (
        <span
          className={styles.policyRange}
          aria-label={`${policyRange} policies`}
        >
          <strong>{policyRange}</strong>
          <small>policies</small>
        </span>
      )}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={tier.reward}
          className={styles.productImage}
          draggable={false}
        />
      )}
    </div>
  );
}

export default RewardProduct;
